import React from 'react'

import type { Props } from './types'
import Button from '../Button'

const InnerTabGroup: React.FC<Props> = ({ tabs, handleClick, active, size }) => {
  return (
    <div className='border-b-soft-green border-b border-solid mb-5'>
      <div className='w-full flex gap-x-4 mb-4 whitespace-nowrap overflow-auto hide-scrollbar bg-soft-green rounded-md'>
        {tabs.map((tab) => {
          const isActive = active === tab.id && tabs.length > 1
          return (
            <Button
              variant={isActive ? 'primary' : 'flat'}
              className='rounded-md px-4'
              key={tab.id}
              onClick={() => handleClick(tab.id)}
              size={size}
            >
              {tab.title}
            </Button>
          )
        })}
      </div>
    </div>
  )
}

export default InnerTabGroup
